import { useEffect } from 'react';
import { Home, ArrowRight } from '../../components/Icons';
import { usePage, PAGES } from '../../context/PageContext';
import { t } from '../../utils/i18n';
import './index.css';

export default function NotFoundPage() {
    const { navigate } = usePage();
    useEffect(() => {
        document.title = t('404 · 页面未找到', '404 · Page Not Found');
    }, []);

    return (
        <div className="notfound-page">
            <div className="notfound-bg" aria-hidden />
            <div className="container notfound-inner">
                <div className="notfound-code" aria-hidden>404</div>
                <h1 className="notfound-title">{t('页面未找到', 'Page Not Found')}</h1>
                <p className="notfound-desc">
                    {t(
                        '你访问的页面可能已被删除、链接失效，或暂未上线。',
                        'The page you are looking for may have been removed, had its link changed, or is temporarily unavailable.'
                    )}
                    <br />
                    {t(
                        '回到首页继续探索至知创新研究院的最新进展。',
                        'Return to the homepage to explore the latest from IQuest Research.'
                    )}
                </p>
                <div className="notfound-actions">
                    <button
                        type="button"
                        className="btn btn-primary btn-large"
                        onClick={() => navigate(PAGES.HOME)}
                    >
                        <Home width={16} height={16} />
                        {t('回到首页', 'Back to Home')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-on-dark-ghost btn-large"
                        onClick={() => navigate(PAGES.RESEARCH)}
                    >
                        {t('探索研究方向', 'Explore Research')}
                        <ArrowRight width={16} height={16} />
                    </button>
                </div>
                <div className="notfound-meta">
                    <button
                        type="button"
                        className="notfound-meta-link"
                        onClick={() => navigate(PAGES.UPDATES)}
                    >
                        {t('动态', 'Updates')}
                    </button>
                    <span className="notfound-meta-dot" aria-hidden>·</span>
                    <button
                        type="button"
                        className="notfound-meta-link"
                        onClick={() => navigate(PAGES.TEAM)}
                    >
                        {t('关于我们', 'About Us')}
                    </button>
                    <span className="notfound-meta-dot" aria-hidden>·</span>
                    <a className="notfound-meta-link" href="mailto:hr@iquestlab.com">{t('联系我们', 'Contact Us')}</a>
                </div>
            </div>
        </div>
    );
}
